/**
 * @file  title/style.ts
 * @description  title core element for support for H 1..5
 *
 *
 * @author ogarcia (ozkary)
 *
 */
import { Typography } from 'antd';

// defines h1, h2...
type Levels = 1 | 2 | 3 | 4 | 5;

// buttons style props
export interface Props {
  level?: Levels;
  className?: string;
  children: string | JSX.Element;
}

// export the title component
export const { Title } = Typography;
